(function () {
  var GIFT_PRODUCT_ID = 15951021506894;
  var busy = false, timer = null;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' \u20AC';
  }

  function render(root, eligible, giftInCart) {
    var threshold = parseInt(root.dataset.threshold, 10) || 10000;
    var messageEl = root.querySelector('[data-gm-gift-message]');
    var barEl = root.querySelector('[data-gm-gift-bar]');
    if (!messageEl || !barEl) return;

    var percent = Math.min(eligible / threshold * 100, 100);
    var msg;
    root.classList.remove('gm-gift-progress--unlocked', 'gm-gift-progress--urgent');

    if (eligible >= threshold) {
      root.classList.add('gm-gift-progress--unlocked');
      msg = '\uD83C\uDF89 \u00A1Has desbloqueado tu regalo! ' +
        (giftInCart ? 'Ya est\u00E1 en tu cesta.' : 'Se a\u00F1adir\u00E1 a tu pedido.');
    } else {
      var remaining = threshold - eligible;
      if (remaining <= threshold * 0.1) root.classList.add('gm-gift-progress--urgent');
      msg = 'Te faltan ' + formatMoney(remaining) + ' para conseguir tu regalo \uD83C\uDF81';
    }
    if (barEl.style.width !== percent + '%') barEl.style.width = percent + '%';
    if (messageEl.textContent !== msg) messageEl.textContent = msg;
  }

  function refreshAll() {
    var roots = document.querySelectorAll('[data-gm-gift-progress]');
    if (!roots.length || busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var eligible = 0, gift = false;
        cart.items.forEach(function (it) {
          if (it.product_id === GIFT_PRODUCT_ID) gift = true;
          else eligible += it.original_line_price;
        });
        document.querySelectorAll('[data-gm-gift-progress]').forEach(function (root) {
          render(root, eligible, gift);
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(refreshAll, delay || 150);
  }

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { schedule(500); schedule(1200); }).catch(function () {});
    }
    return p;
  };

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('[data-gm-gift-progress]') || n.querySelector('[data-gm-gift-progress]'))) {
          schedule(50);
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('gm:cart-refreshed', function () { schedule(50); });
  document.addEventListener('DOMContentLoaded', function () { schedule(0); });
  window.addEventListener('pageshow', function () { schedule(0); });
  if (document.readyState !== 'loading') schedule(0);
})();